/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { IEvidenceInput } from 'uplisting-frontend/components/ui/protection/dispute-panel/response';
import type { DisputeEvidenceTextField } from 'uplisting-frontend/models/dispute';

interface IArgs {
  inputs: IEvidenceInput[];

  onChange(key: DisputeEvidenceTextField, event: Event): void;
}

interface UiProtectionDisputePanelResponseFieldsSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiProtectionDisputePanelResponseFieldsComponent =
  templateOnly<UiProtectionDisputePanelResponseFieldsSignature>();

export default UiProtectionDisputePanelResponseFieldsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Response::Fields': typeof UiProtectionDisputePanelResponseFieldsComponent;
    'ui/protection/dispute-panel/response/fields': typeof UiProtectionDisputePanelResponseFieldsComponent;
  }
}
